import React from 'react'
import { CardHeader, Heading, Flex } from 'uikit'
import styled from 'styled-components'
import { useTranslation } from 'contexts/Localization'
import { Token } from 'config/constants/types'
import TokenPairImage from 'components/TokenPairImage'
import tokens from 'config/constants/tokens'

const Wrapper = styled(CardHeader)<{ isFinished?: boolean; background?: string }>`
  background: linear-gradient(90deg, #c45bec, #9112ff);
`

const StyledCardHeader: React.FC<{
  stakingToken: Token
  isFinished?: boolean
  isStaking?: boolean
}> = ({ stakingToken, isFinished = false, isStaking = false }) => {
  const { t } = useTranslation()
  const background = isStaking ? 'bubblegum' : 'cardHeader'

  return (
    <Wrapper p="32px 22px 26px 26px" isFinished={isFinished} background={background}>
      <Flex alignItems="center" justifyContent="space-between">
        <TokenPairImage primaryToken={stakingToken} secondaryToken={tokens.dmd} width={44} height={44} />
        <Flex flexDirection="column">
          <Heading color="#FFFFFF" scale="md">
            {t('Stake %symbol%', { symbol: stakingToken.symbol })}
          </Heading>
        </Flex>
      </Flex>
    </Wrapper>
  )
}

export default StyledCardHeader
